export const lang = {
    "item1":"關於",
    "item2":"產品與服務",
    "item3":"聯繫我們",
    "intro1":"NDC（New Distribution Capability 新分銷能力）是國際航空運輸協會（IATA）的一項新分銷標準，航司可通過NDC標準向代理商提供豐富的產品信息、個性化的產品、完善的服務功能。",
    "intro2":"SmartNDC是一個航司NDC服務的聚合器，幫助代理商對接航司NDC，提供簡單豐富的JSON API接口，在線預訂工具，手機預訂頁面等。可以滿足代理商的客戶管理，渠道分銷的需求。支持基於NDC的選座、行李、貴賓室、往返、多程等。",    
    "title1":"在線預訂工具",
    "subtitle1":"航司NDC產品的在線預訂與管理，滿足自訂與分銷的需求。",
    "title2":"手機預訂頁面",
    "subtitle2":"自適應的手機預訂頁面，方便手機訪問或嵌入手機應用。",    
    "title3":"簡潔的JSON API",
    "subtitle3":"滿足基本的預定、出票需求，減少開發與集成的複雜度。",
    "title4":"詳細的JSON API",
    "subtitle4":"支持航司NDC的全部功能，方便定制開發各種應用。",       
    "title5":"可選擇雲服務",
    "subtitle5":"靈活快速使用，減少部署和運營成本。",
    "title6":"可本地部署",
    "subtitle6":"保障私密數據的安全性，可定制開發。",    
    "title7":"功能升級",
    "subtitle7":"持續免費的產品功能升級，以適應NDC技術發展。",
    "title8":"技術服務",
    "subtitle8":"7*24小時技術服務，保障運營不間斷。",        
    "copyright":"北京點動創想科技有限公司", 
    "c_name":"名稱*", 
    "c_email":"郵箱*", 
    "c_phone":"電話*", 
    "c_message":"諮詢信息*", 
    "c_send":"發送", 
}